import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

const defaultData: IDataLayer = {
  sppOpenBopisOverlay: {
    event_name: 'delivery_options',
    event_category: 'delivery options',
    event_action: 'launched',
    event_label: 'bopis',
  },

  bopisStoreClick: {
    event_name: 'delivery_options',
    event_category: 'bopis',
    event_action: 'store search selection',
    event_label: null, // <store_name>
  },

  bopisSearch: {
    event_name: 'checkout_option',
    event_category: 'ecommerce',
    event_action: 'bopis zipcode search',
    event_label: null, // <page_type>
  },

  bopisSearchCurrentLocation: {
    event_name: 'delivery_options',
    event_category: 'delivery options',
    event_action: 'store search',
    event_label: 'location search',
  },

  bopisSelectStore: {
    event_name: 'delivery_options',
    event_category: 'bopis',
    event_action: 'store selected for purchase',
    event_label: null, // <store_name>
  },

  bopisSearchResults: {
    event_name: 'delivery_options',
    event_category: 'delivery options',
    event_action: 'store results',
    event_label: null, // <number of results returned>
  },

  bopisSelectDeliveryOption: {
    event_name: 'checkout_option',
    enh_action: 'checkout_option',
    event_category: 'ecommerce',
    event_action: 'order delivery type',
    event_label: null, // '<delivery_type>'
  },

  bopisEditBagAction: {
    event_name: 'checkout_option',
    event_category: 'ecommerce',
    event_action: 'BOPIS - items unavailable',
    event_label: null, // '<selected menu item>'
  },

  bopisRemoveUnavailableItems: {
    event_name: 'checkout_option',
    event_category: 'ecommerce',
    event_action: 'BOPIS - remove unavailable items',
    event_label: null, // '<selected menu item>'
  },

  bopisEditDeliveryType: {
    event_name: 'checkout_option',
    event_category: 'ecommerce',
    event_action: 'edit delivery type',
    event_label: null, // '<selected delivery type>'
  },

  bopisEditBagClick: {
    event_name: 'delivery_options',
    event_category: 'bopis',
    event_action: 'store search',
    event_label: 'edit bag',
  },
};

/*
// TODO:

Currently the drupal code that calls this passes in just an object with the following structure:
{
  action: 'bopisStoreClick',
  payload: { event_label: that.doors[i] && that.doors[i].DOORNAME + ' ' + (that.doors[i].SUB_HEADING || '') }
}

This is different than what has been standardized here below. So the drupal code (or whatever is being ported to this repository) needs to be updated to pass in the correct data structure.

See current drupal implementation here: sites/esteelauder/modules/custom/esteelauder_product/libraries/bopis_v1/bopis_v1.js

*/

function trackBopis(eventName: string, eventData: IDataLayer = {}) {
  tealium.evtLink({ ...defaultData[eventName], ...eventData });
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackBopis);
});
